module.exports = __webpack_public_path__ + "img/3.2774cc52.png";